import React from "react";

import classnames from "classnames";

const INDICATORS = [
	{ name: "Crosshair", onClickParams: { type: "Crosshair" } },
	{ name: "TrendLine", onClickParams: { type: "TrendLine" } },
	{ name: "Fib Retracement", onClickParams: { type: "Fib Retracement" } },
];

const TOOLTIP = `To remove an indicator drawn, select the type of indicator to remove and then press ctrl + right click
For Trendline - press shift to temporarily disable the snap`;

export default class InteractiveIndicator extends React.Component {
	render() {
		var classes = classnames({
			"dropdown": true,
			"open": this.props.showDropDown
		});
		var { setInteractiveIndicator, type } = this.props;
		return (
			<div className="indicators" data-intro="change interactive indicators">
				<div className={classes}  >
					<button className="btn btn-default dropdown-toggle" type="button" id="dropdownMenu1"
							data-toggle="dropdown" onClick={this.props.onDropDownToggle}>
						{type} <span className="caret"></span>
					</button>
					<ul className="dropdown-menu">
						{INDICATORS.map((each, idx) => 
							<li key={idx}>
								<a tabIndex="-1" href="#"
									onClick={setInteractiveIndicator.bind(null, each.onClickParams.type)}>{each.name}</a>
							</li>)}
					</ul>
					<span className="indicators glyphicon glyphicon-question-sign" title={TOOLTIP}></span>
				</div>
			</div>

		);
	}
}

/*
			<div data-intro="change interactive indicators" data-step={3}>
				<div className="btn-group interactive-indicator">
					<button type="button" className="btn btn-default">
						<svg height="16" width="16">
							<line x1="8" y1="0" x2="8" y2="16" stroke="black" strokeWidth="1" fill="none" />
						</svg>
					</button>
				</div>
				<div className="btn-group interactive-indicator">
						<svg height="34" width="34">
							<line x1="17" y1="7" x2="17" y2="27" stroke="black" strokeWidth="1" fill="none" />
							<line x1="7" y1="17" x2="27" y2="17" stroke="black" strokeWidth="1" fill="none" />
						</svg>
				</div>
				<div className="btn-group interactive-indicator">
					<button type="button" className="btn btn-default">
						<span className="glyphicon glyphicon-cog"></span>
					</button>
				</div>
			</div>
						<li className=" search">
							<form className="navbar-form navbar-left" role="search">
								<div className="form-group">
									<input type="text" className="form-control" placeholder="Filter" />
								</div>
							</form>
						</li>
*/


/** WEBPACK FOOTER **
 ** ./src/scripts/components/page/ChartPage/InteractiveIndicator.jsx
 **/